var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('editor',{attrs:{"id":"tinymce","disabled":_vm.isDisabled,"init":_vm.init},model:{value:(_vm.tinymceHtml),callback:function ($$v) {_vm.tinymceHtml=$$v},expression:"tinymceHtml"}})}
var staticRenderFns = []

export { render, staticRenderFns }